import React, {FC} from 'react';

import {PRESCRIPTION_METHOD} from 'constants/product';
import {CheckoutItemType} from 'desktop/types/checkoutItemsType';

import {CartItemLensesDetailsRow} from '../cartItemDetailsRow/cartItemLensesDetailsRow';
import {CartItemDetailsRowV2} from '../cartItemDetailsRowV2/cartItemDetailsRowV2';

import {SendPrescriptionLater} from '../sendPrescriptionLater/sendPrescriptionLater';

import s from './lensesCartItemDetails.scss';

type PropsType = {
    item: CheckoutItemType;
};

/**
 * Cart lenses item collapsible content
 */
export const LensesCartItemDetails: FC<PropsType> = ({item}) => (
    <div className={s.wrapper}>
        {Object.values(item.options)
            .sort((a, b) => a.option.sort - b.option.sort)
            .map(({option}) => (
                <CartItemLensesDetailsRow item={item} key={option.title} title={option.title} />
            ))}
        {item.prescription && (
            <CartItemDetailsRowV2
                dataTestName="PrescriptionTypeInfo"
                label="Prescription type:"
                prescription={item.prescription}
                prescriptionType={item.contactLensPrescriptionType}
                title={item.prescription.name}
                forLenses
            />
        )}
        {item.prescription?.method === PRESCRIPTION_METHOD.SEND_EMAIL_OR_FAX_METHOD && (
            <SendPrescriptionLater className={s.sendPrescription} withFax={false} />
        )}
    </div>
);
